import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class RegionRoleService {
  private regionSubject = new BehaviorSubject<string | null>(localStorage.getItem('selectedRegion'));
  private roleSubject = new BehaviorSubject<string | null>(localStorage.getItem('selectedRole'));
  private displayRegionSubject = new BehaviorSubject<string | null>(localStorage.getItem('selectedDisplayRegion'));

  region$ = this.regionSubject.asObservable();
  role$ = this.roleSubject.asObservable();
  displayRegion$ = this.displayRegionSubject.asObservable();

  setRegion(region: string) {
    localStorage.setItem('selectedRegion', region);
    this.regionSubject.next(region);
    // Also update subject in case other code changed localStorage directly
    setTimeout(() => {
      this.regionSubject.next(localStorage.getItem('selectedRegion'));
    }, 0);
  }
  setDisplayRegion(region: string) {
    if(region.toLocaleLowerCase() === 'vcoplanner'){
      region = 'SupplyPlanner';
    }
    localStorage.setItem('selectedDisplayRegion', region);
    this.displayRegionSubject.next(region);
    // Also update subject in case other code changed localStorage directly
    setTimeout(() => {
      this.displayRegionSubject.next(localStorage.getItem('selectedDisplayRegion'));
    }, 0);
  }

  
  // For cross-tab sync
  setRole(role: string) {
    localStorage.setItem('selectedRole', role);
    this.roleSubject.next(role);
    setTimeout(() => {
      this.roleSubject.next(localStorage.getItem('selectedRole'));
    }, 0);
  }
  
  listenToStorageEvents() {
    window.addEventListener('storage', (event) => {
      if (event.key === 'selectedRegion') {
        // Always update from localStorage to ensure latest value
        this.regionSubject.next(localStorage.getItem('selectedRegion'));
      }
      if (event.key === 'selectedRole') {
        this.roleSubject.next(localStorage.getItem('selectedRole'));
      }
    });
  }
}
